import { useDispatch } from "react-redux";
import { Copyright, TypographyCopyright } from "./GrandCombinStyles";
import { DIALOG_TYPES, DIALOGS } from "../../../Dialogs/dialogReducer";

export const GrandCombinExamFooter = ({
  examName,
  zoomFactor,
  title,
  objectiveIndex,
}: {
  examName: string;
  zoomFactor: number;
  title: string;
  objectiveIndex: number;
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <Copyright
        zoomfactor={zoomFactor}
        onClick={() =>
          dispatch({ type: DIALOG_TYPES.OPEN_DIALOG, payload: { dialogName: DIALOGS.RENAME_EXAM_DIALOG } })
        }
      >
        <TypographyCopyright zoomfactor={zoomFactor}>{examName}</TypographyCopyright>
        <TypographyCopyright zoomfactor={zoomFactor}>
          {" "}
          © didacto - {title} - Kompetenz {objectiveIndex}
        </TypographyCopyright>
      </Copyright>
    </>
  );
};

export default GrandCombinExamFooter;
